var Backbone = require('backbone');
var _ = require('lodash');
var template = require('../templates/footer.ejs');

'use strict';
module.exports = Backbone.View.extend({
    className: 'footer',
    events: {
        'click .route-faq': 'routeFAQ'
    },
    /**
   *
   */
    initialize: function (options) {
        this.cms = options.cms;
        this.router = options.router;
    },
    /**
   *
   */
    render: function () {

        var styles = this.cms.get('text').design;
        var footer = this.cms.get('text').views_page_footer;
        var footerCopy = footer.footer_copy;

        var regEx = /.<img./;

        if (!_.isArray(footerCopy.match(regEx))) {
            footerCopy = footerCopy.slice(0,57);
            footer.footer_copy = footerCopy;
        }

        var model = {
            text: footer,
            faq: this.cms.get('text').views_faq,
            copy: styles.css.footer.link_color
        };
        console.log(model.faq, ' Footer VIEW RENDER');
        this.$el.html(template(model));

        return this;
    },
    /**
   *
   */
    routeFAQ: function (e) {
    //this.router.navigate('loading/generic', {trigger: true});
        var faq = this.cms.get('text').views_faq;
        if(faq.enable_faq_modal == 'true'){
            e.preventDefault();
            this.router.faq();
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/standard-vote/app/scripts/views/footer.js
// module id = 220
// module chunks = 0